const ENGLISH_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;
const FRENCH_MONTHS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const;
const englishLanguageSelected = 'English';

export function parseDateToLanguage(monthNumber: number, language: string) {
  if (language === englishLanguageSelected) {
    return ENGLISH_MONTHS[monthNumber];
  }
  return FRENCH_MONTHS[monthNumber];
}

export function getLinkTextFromDate(lastUpdateDate: string | null, languageSelected: string): string {
  if (lastUpdateDate) {
    const officialDate = new Date(lastUpdateDate.toString());
    const monthNumber = officialDate.getMonth();
    const parsedMonth = parseDateToLanguage(monthNumber, languageSelected);
    const parsedDate = `${parsedMonth} ${officialDate.getDate()}, ${officialDate.getFullYear()}`;
    return `Last Updated: ${parsedDate}`;
  }
  return 'Not Started';
}
